import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import InvitationCreateDialog from "@/v2-backoffice-client/invitation/create/InvitationCreateDialog"

export type InvitationCreateButtonProps = ButtonProps

function InvitationCreateButton(props: InvitationCreateButtonProps) {
  const { onClick, children, ...buttonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Invite user"}
      </Button>

      <InvitationCreateDialog open={isOpen} onOpenChange={setIsOpen} />
    </>
  )
}

export default InvitationCreateButton
